/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Meta_DescriptionInputs */

const en_directory_vibebids_meta_description = /** @type {(inputs: Directory_Vibebids_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid for a public Seek AI ranking. The highest bid wins each product discovery spot.`)
};

const zh_directory_vibebids_meta_description = /** @type {(inputs: Directory_Vibebids_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为公开的 Seek AI 排名出价，价高者赢得每个产品曝光位。`)
};

/**
* | output |
* | --- |
* | "Bid for a public Seek AI ranking. The highest bid wins each product discovery spot." |
*
* @param {Directory_Vibebids_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_meta_description = /** @type {((inputs?: Directory_Vibebids_Meta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Meta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_meta_description(inputs)
	return zh_directory_vibebids_meta_description(inputs)
});
export { directory_vibebids_meta_description as "directory.vibebids.meta_description" }